"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyRightBox = exports.StyledIcon500px = exports.FooterLink = exports.FooterBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _filteredLink = _interopRequireDefault(require("../../../../../filteredLink"));

var _StyledLayout = require("../../../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../../../MediaQueries"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FooterBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__FooterBox",
  componentId: "sc-1rntrnh-0"
})(["position:fixed;left:0;bottom:0;z-index:3;width:100%;height:56px;padding:0 ", ";background:", ";display:flex;align-items center;justify-content:center;", ";#logo_svg{width:48px}svg{path{fill:", ";}}a{&:hover{color:", ";font-weight:bold;}}"], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.portfolioBackground1;
}, _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    padding: 0 48px;\n    justify-content: space-between;\n  "]))), function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme[props.colour];
});
exports.FooterBox = FooterBox;
var FooterLink = (0, _styledComponents["default"])((0, _filteredLink["default"])(['underline'])).withConfig({
  displayName: "Elements__FooterLink",
  componentId: "sc-1rntrnh-1"
})(["", ";"], function (props) {
  return props.underline && (0, _styledComponents.css)(["text-decoration:underline;"]);
});
exports.FooterLink = FooterLink;
var StyledIcon500px = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledIcon500px",
  componentId: "sc-1rntrnh-2"
})(["width:48px;svg{width:48px;path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledIcon500px = StyledIcon500px;
var CopyRightBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__CopyRightBox",
  componentId: "sc-1rntrnh-3"
})(["display:flex;align-items:center;flex-direction:column;", " a{&:hover{color:", " font-weight:bold;}}@media (max-width:", "px){padding:0;}"], _MediaQueries["default"].minWidth.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: row;\n    justify-content: space-between;\n  "]))), function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme.responsiveSmall;
});
exports.CopyRightBox = CopyRightBox;